import { useEffect } from 'react';
import Hotjar from '@hotjar/browser';
import { getLoggedInUserSubId } from '@/helpers/auth';

const HOTJAR_SITE_ID = import.meta.env.VITE_HOTJAR_ID;
const HOTJAR_VERSION = import.meta.env.VITE_HOTJAR_VERSION;

export function HotjarProvider({ children }: { children: React.ReactNode }) {

  useEffect(() => {
    if (HOTJAR_SITE_ID && HOTJAR_VERSION) {
      Hotjar.init(Number(HOTJAR_SITE_ID), HOTJAR_VERSION);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const userSubId = getLoggedInUserSubId();

    if (HOTJAR_SITE_ID && userSubId) {
      Hotjar.identify(userSubId, {});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
}
